import React from 'react';
import '../../../../assets/css/Modal.css'
import {
    Modal,
} from 'react-bootstrap';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import QltsUserController from "../../../../services/qlts/qlts-user-controller";
import DatePicker from "react-datepicker";
import moment from "moment";

class ModalCreateCustomerPayment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            customerId: "",
            childName:"",
            money: "",
            content: '',
            payDate: new Date()
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps, nextContext){
        if (nextProps.show){
            this.setState({
                customerId: nextProps.info?.customerId,
                childName:nextProps.info?.childName,
                money: "",
                content: '',
                status: 'ACTIVE',
                payDate: new Date(),
            });
        }
    }
    createCustomerPayment = () => {
        let money = parseInt(this.state.money.toString().replaceAll(",", ""))
        if (isNaN(money)){
            toast.warning("Tiền không đúng định dạng!", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }else {
            let payload = {
                customerId: this.state.customerId,
                paymentReq: {
                    content: this.state.content,
                    money: money,
                    payDate: this.state.payDate,
                    status: this.state.status,
                }
            }
            QltsUserController.createCustomerPayment(payload, res => {
                if (res.success) {
                    toast.success("Thêm hóa đơn thành công!", {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 2000
                    });
                    this.props.onHide();
                    this.props.onRefresh()
                } else {
                    toast.warning(res.message[0], {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 3000
                    });
                }
            })
        }

    }
    formatMoney(num) {
        num = num.toString().replaceAll(",", "")
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }
    render() {
        const modalProp = {
            show: this.props.show,
            onHideModal: this.props.onHide,
            keyboard: false,
            backdrop: 'static',
        };
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered">
                    <div className="modal-container">
                        <div className="btn-close">
                            <button type="button" className="close" onClick={this.props.onHide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <Modal.Body>
                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>Thêm giao dịch nộp tiền</b></h1>
                        </div>
                        <div className='d-flex justify-content-center mt-12 mb-12'>
                            <div className="row">
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Tên con</label>
                                    <label className="col-6 label-item pl-0">{this.state.childName}</label>
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Số tiền nộp(<span  style={{color: "red",}}>*</span>)</label>
                                    <input
                                        placeholder="Nhập số tiền nộp"
                                        maxLength={255}
                                        type="text"
                                        className="form-control shadow-none"
                                        value={this.formatMoney(this.state.money)}
                                        onChange={(event) => {
                                            this.setState({
                                                money: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Ngày nộp</label>
                                    <DatePicker
                                        locale="vi"
                                        className="w-auto  form-control kt-input pd-4-input hei-input"
                                        selected={this.state.payDate === '' ? null : new Date(this.state.payDate)}
                                        maxDate={new Date()}
                                        placeholderText="Ngày-Tháng-Năm"
                                        dateFormat="dd-MM-yyyy"
                                        showMonthDropdown
                                        showYearDropdown
                                        onChange={
                                            (date) => {
                                                let value = moment(date).format("YYYY-MM-DD").toString();
                                                try {
                                                    this.setState({
                                                        payDate: value == "Invalid date" ? null : moment(value).format("YYYY-MM-DD"),
                                                    })
                                                }catch (e) {

                                                }
                                            }
                                        }
                                    />
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Ghi chú</label>
                                    <input
                                        placeholder="Ghi chú"
                                        maxLength={255}
                                        type="text"
                                        className="form-control shadow-none"
                                        value={this.state.content}
                                        onChange={(event) => {
                                            this.setState({
                                                content: event.target.value
                                            })
                                        }}
                                    />
                                </div>

                            </div>
                        </div>

                        <div className="d-flex align-right col-md-12 col-xs-12 row">
                            <div className="d-flex justify-content-center align-center mt-3 mb-2 col-md-12 col-xs-12">
                                <button
                                    style={{minWidth: "fit-content", marginRight: "10px"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s background-btn w-50 type-button-fix btn btn-primary"
                                    onClick={() => this.createCustomerPayment()}
                                >
                                        <span className='justify-content-center'>
                                            Tạo
                                        </span>
                                </button>
                                <button
                                    style={{minWidth: "fit-content"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s w-50 type-button-fix btn btn-secondary"
                                    onClick={this.props.onHide}
                                >
                                        <span className=''>
                                            Hủy
                                        </span>
                                </button>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}
export default ModalCreateCustomerPayment
